var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", { domProps: { innerHTML: _vm._s(_vm.model.Step5aTitle) } }),
        _vm._v(" "),
        _c("p", { staticClass: "qualifier-tool-subheader-alt " }, [
          _vm._v(_vm._s(_vm.model.Step5aSubTitle))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row qualifier-tool-form-row justify-content-between" },
      [
        _c("div", { staticClass: "qualifier-tool-form-content" }, [
          _c("p", [_vm._v(_vm._s(_vm.model.Step5aAssistedLivingTitle))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "qualifier-tool-form-container" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.assistedLiving,
                expression: "assistedLiving"
              }
            ],
            staticClass: "qualifier-tool-form-radio",
            attrs: {
              type: "radio",
              id: "AssistedLiving_yes",
              name: "AssistedLiving",
              required: ""
            },
            domProps: {
              value: true,
              checked: _vm._q(_vm.assistedLiving, true)
            },
            on: {
              change: function($event) {
                _vm.assistedLiving = true
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "qualifier-tool-form-radio-label",
              attrs: { for: "AssistedLiving_yes", tabindex: "0" },
              on: {
                keypress: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  _vm.assistedLiving = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.model.PositiveResponseButtonText))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.assistedLiving,
                expression: "assistedLiving"
              }
            ],
            staticClass: "qualifier-tool-form-radio",
            attrs: {
              type: "radio",
              id: "AssistedLiving_no",
              name: "AssistedLiving",
              required: ""
            },
            domProps: {
              value: false,
              checked: _vm._q(_vm.assistedLiving, false)
            },
            on: {
              change: function($event) {
                _vm.assistedLiving = false
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "qualifier-tool-form-radio-label",
              attrs: { for: "AssistedLiving_no", tabindex: "0" },
              on: {
                keypress: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  _vm.assistedLiving = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.model.NegativeResponseButtonText))]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row qualifier-tool-form-row" }, [
      _c("div", { staticClass: "qualifier-tool-form-content" }, [
        _c("p", [_vm._v(_vm._s(_vm.model.Step5aPastSixMonthsTitle))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qualifier-tool-form-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.pastSixMonths,
              expression: "pastSixMonths"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "PastSixMonths_yes",
            name: "PastSixMonths",
            required: ""
          },
          domProps: { value: true, checked: _vm._q(_vm.pastSixMonths, true) },
          on: {
            change: function($event) {
              _vm.pastSixMonths = true
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "PastSixMonths_yes", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.pastSixMonths = true
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.PositiveResponseButtonText))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.pastSixMonths,
              expression: "pastSixMonths"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "PastSixMonths_no",
            name: "PastSixMonths",
            required: ""
          },
          domProps: { value: false, checked: _vm._q(_vm.pastSixMonths, false) },
          on: {
            change: function($event) {
              _vm.pastSixMonths = false
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "PastSixMonths_no", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.pastSixMonths = false
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.NegativeResponseButtonText))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row qualifier-tool-form-row" }, [
      _c("div", { staticClass: "qualifier-tool-form-content" }, [
        _c("p", [_vm._v(_vm._s(_vm.model.Step5aMedicaidRecipientTitle))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qualifier-tool-form-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.medicaidRecipient,
              expression: "medicaidRecipient"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "MedicaidRecipient_yes",
            name: "MedicaidRecipient",
            required: ""
          },
          domProps: {
            value: true,
            checked: _vm._q(_vm.medicaidRecipient, true)
          },
          on: {
            change: function($event) {
              _vm.medicaidRecipient = true
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "MedicaidRecipient_yes", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.medicaidRecipient = true
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.PositiveResponseButtonText))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.medicaidRecipient,
              expression: "medicaidRecipient"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "MedicaidRecipient_no",
            name: "MedicaidRecipient",
            required: ""
          },
          domProps: {
            value: false,
            checked: _vm._q(_vm.medicaidRecipient, false)
          },
          on: {
            change: function($event) {
              _vm.medicaidRecipient = false
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "MedicaidRecipient_no", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.medicaidRecipient = false
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.NegativeResponseButtonText))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row qualifier-tool-form-row" }, [
      _c("div", { staticClass: "qualifier-tool-form-content" }, [
        _c("p", [_vm._v(_vm._s(_vm.model.Step5aNeedAssistanceTitle))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qualifier-tool-form-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.needsAssistance,
              expression: "needsAssistance"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "NeedsAssistance_yes",
            name: "NeedsAssistance",
            required: ""
          },
          domProps: { value: true, checked: _vm._q(_vm.needsAssistance, true) },
          on: {
            change: function($event) {
              _vm.needsAssistance = true
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "NeedsAssistance_yes", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.needsAssistance = true
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.PositiveResponseButtonText))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.needsAssistance,
              expression: "needsAssistance"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "NeedsAssistance_no",
            name: "NeedsAssistance",
            required: ""
          },
          domProps: {
            value: false,
            checked: _vm._q(_vm.needsAssistance, false)
          },
          on: {
            change: function($event) {
              _vm.needsAssistance = false
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "NeedsAssistance_no", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.needsAssistance = false
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.NegativeResponseButtonText))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row qualifier-tool-form-row" }, [
      _c("div", { staticClass: "qualifier-tool-form-content" }, [
        _c("p", [_vm._v(_vm._s(_vm.model.Step5aNeedTransportationTitle))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qualifier-tool-form-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.needsTransportation,
              expression: "needsTransportation"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "NeedsTransportation_yes",
            name: "NeedsTransportation",
            required: ""
          },
          domProps: {
            value: true,
            checked: _vm._q(_vm.needsTransportation, true)
          },
          on: {
            change: function($event) {
              _vm.needsTransportation = true
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "NeedsTransportation_yes", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.needsTransportation = true
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.PositiveResponseButtonText))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.needsTransportation,
              expression: "needsTransportation"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "NeedsTransportation_no",
            name: "NeedsTransportation",
            required: ""
          },
          domProps: {
            value: false,
            checked: _vm._q(_vm.needsTransportation, false)
          },
          on: {
            change: function($event) {
              _vm.needsTransportation = false
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "NeedsTransportation_no", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.needsTransportation = false
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.NegativeResponseButtonText))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row qualifier-tool-form-row" }, [
      _c("div", { staticClass: "qualifier-tool-form-content" }, [
        _c("p", [_vm._v(_vm._s(_vm.model.Step5aMedicareRecipientTitle))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qualifier-tool-form-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.medicareRecipient,
              expression: "medicareRecipient"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "MedicareRecipient_yes",
            name: "MedicareRecipient",
            required: ""
          },
          domProps: {
            value: true,
            checked: _vm._q(_vm.medicareRecipient, true)
          },
          on: {
            change: function($event) {
              _vm.medicareRecipient = true
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "MedicareRecipient_yes", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.medicareRecipient = true
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.PositiveResponseButtonText))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.medicareRecipient,
              expression: "medicareRecipient"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "MedicareRecipient_no",
            name: "MedicareRecipient",
            required: ""
          },
          domProps: {
            value: false,
            checked: _vm._q(_vm.medicareRecipient, false)
          },
          on: {
            change: function($event) {
              _vm.medicareRecipient = false
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "MedicareRecipient_no", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.medicareRecipient = false
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.NegativeResponseButtonText))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row qualifier-tool-form-row" }, [
      _c("div", { staticClass: "qualifier-tool-form-content" }, [
        _c("p", [_vm._v(_vm._s(_vm.model.Step5aVeteranTitle))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qualifier-tool-form-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.veteran,
              expression: "veteran"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "Veteran_yes",
            name: "Veteran",
            required: ""
          },
          domProps: { value: true, checked: _vm._q(_vm.veteran, true) },
          on: {
            change: function($event) {
              _vm.veteran = true
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "Veteran_yes", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.veteran = true
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.PositiveResponseButtonText))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.veteran,
              expression: "veteran"
            }
          ],
          staticClass: "qualifier-tool-form-radio",
          attrs: {
            type: "radio",
            id: "Veteran_no",
            name: "Veteran",
            required: ""
          },
          domProps: { value: false, checked: _vm._q(_vm.veteran, false) },
          on: {
            change: function($event) {
              _vm.veteran = false
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "qualifier-tool-form-radio-label",
            attrs: { for: "Veteran_no", tabindex: "0" },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.veteran = false
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.NegativeResponseButtonText))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "p",
          {
            staticClass: "qualifier-tool-aditional-btn",
            class: {
              "qualifier-tool-aditional-btn-active": _vm.isAditionalInfo
            },
            attrs: { tabindex: "0" },
            on: {
              click: function($event) {
                _vm.isAditionalInfo = true
              },
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.isAditionalInfo = true
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.Step5aAdditionalInfoToggleTitle))]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.isAditionalInfo
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.aditionalInfo,
                  expression: "aditionalInfo"
                }
              ],
              staticClass: "qualifier-tool-aditional-textarea",
              attrs: {
                tabindex: "0",
                placeholder: _vm.model.Step5aAdditionalInfoTogglePlaceholder
              },
              domProps: { value: _vm.aditionalInfo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.aditionalInfo = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "qualifier-tool-aditional-subtitle" }, [
              _vm._v(_vm._s(_vm.model.Step5aAdditionalInfoTitle))
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row d-flex justify-content-center qualifier-tool-footer"
      },
      [
        _c(
          "button",
          {
            staticClass: "qualifier-tool-btn",
            attrs: {
              type: "button",
              disabled: _vm.disableSubmit,
              tabindex: "0"
            },
            on: {
              click: function($event) {
                return _vm.nextStepValidation()
              }
            }
          },
          [_vm._v(_vm._s(_vm.model.SubmitButtonText))]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "qualifier-tool-status-bar" }, [
        _c(
          "div",
          {
            staticClass:
              "qualifier-tool-status-number qualifier-tool-status-number-active"
          },
          [_vm._v("1")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "qualifier-tool-status-number qualifier-tool-status-number-active"
          },
          [_vm._v("2")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "qualifier-tool-status-number qualifier-tool-status-number-active"
          },
          [_vm._v("3")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }